import { useMemo } from 'react';
import type { QuickEntriesJobFile } from '@/types/gql.generated';
import { Flex } from '@/ui';
import { isPdfFile, isPdfFromServer } from '@/utils/file';
import { ImageRenderer } from './ImageRenderer';
import { PdfRenderer } from './PdfRenderer';

type Props = {
  file: File | QuickEntriesJobFile;
  maxImageWidth?: number;
  maxImageHeight?: number;
  pdfZoomEnabled?: boolean;
  imageZoomEnabled?: boolean;
};

export const FilePreview = ({
  file,
  maxImageWidth,
  maxImageHeight,
  pdfZoomEnabled = true,
  imageZoomEnabled = true,
}: Props) => {
  const src = useMemo(() => {
    if (file instanceof File) {
      return URL.createObjectURL(file);
    }
    return file.url;
  }, [file]);

  return (
    <Flex justify="center" width="100%">
      {isPdfFile(file) ? (
        <PdfRenderer file={file} zoomEnabled={pdfZoomEnabled} />
      ) : isPdfFromServer(file) ? (
        <PdfRenderer file={file.url} zoomEnabled={pdfZoomEnabled} />
      ) : (
        <ImageRenderer
          maxImageHeight={maxImageHeight}
          maxImageWidth={maxImageWidth}
          src={src}
          zoomEnabled={imageZoomEnabled}
        />
      )}
    </Flex>
  );
};
